// Toggle product information
$(document).on('click', '.product-toggle', function() {
  var id = $(this).attr('id');

  $('#product-' + id + ' .products__article__hover').toggleClass('active');
});
